import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private profileSource = new BehaviorSubject<{ completeProfile: boolean, preRegisteredData: any }>({
    completeProfile: false,
    preRegisteredData: null
  });

  profile$ = this.profileSource.asObservable();

  updateProfileData(completeProfile: boolean, preRegisteredData: any) {
    this.profileSource.next({ completeProfile, preRegisteredData });
  }
}
